import React from "react";
import { useTranslation } from "react-i18next";

import { FilterItemTypes } from "configs/types";

import Filter from "components/global/Filter/Filter";

import gridIcon from "assets/icons/grid-icon.svg";
import { NotificationEmailTypes } from "store/emails/slice";

type Filter = {
  value: string | number;
  label: string;
};

interface Props {
  filterByTitle: string;
  onFilterSearchByTitle: (e: string) => void;
  handleApply: () => void;
  onFilterByType: (e: Filter[]) => void;
  onFilterByActive: (e: Filter[]) => void;
  onFilterByKey: (e: string) => void;
  filterByType: Filter[];
  filterByActive: Filter[];
  filterByKey: string;
  types: string[];
}
const NotificationsEmailFilter: React.FC<Props> = ({
  handleApply,
  onFilterSearchByTitle,
  onFilterByType,
  onFilterByActive,
  onFilterByKey,
  filterByTitle,
  filterByType,
  filterByActive,
  filterByKey,
  types,
}) => {
  const { t } = useTranslation();

  const handleSelectType = (e: Filter[]) => {
    if (e.length === 0 || e[0].value === NotificationEmailTypes.all) {
      onFilterByType([]);

      return;
    }

    onFilterByType(e);
  };

  const handleApplyFilters = () => {
    handleApply();
  };

  const handleClearFilters = () => {
    handleSelectType([]);
    onFilterByActive([]);
    onFilterSearchByTitle("");
    onFilterByKey("");
    handleApply();
  };

  const handleSelectActive = (e: Filter[]) => {
    if (e[0]?.value === 3) {
      onFilterByActive([]);

      return;
    }

    onFilterByActive(e);
  };

  return (
    <Filter
      className="notifications-email-filter"
      handleClear={handleClearFilters}
      handleApply={handleApplyFilters}
      filterItems={[
        {
          type: FilterItemTypes.input,
          title: t("title"),
          boxTitle: t("title"),
          icon: gridIcon,
          inputValue: filterByTitle,
          inputType: "string",
          setInputValue: onFilterSearchByTitle,
        },
        {
          type: FilterItemTypes.input,
          title: t("filterKey"),
          boxTitle: t("filterKey"),
          icon: gridIcon,
          inputValue: filterByKey,
          inputType: "string",
          setInputValue: onFilterByKey,
        },
        {
          type: FilterItemTypes.radio,
          title: t("isActive"),
          boxTitle: t("isActive"),
          icon: gridIcon,
          itemsArray: [
            {
              label: "Active",
              value: 1,
            },
            {
              label: "Inactive",
              value: 0,
            },
            {
              label: "All",
              value: 3,
            },
          ],
          activeItems: filterByActive.length
            ? filterByActive
            : [{ label: "All", value: 3 }],
          handleApply: handleSelectActive,
        },
        {
          type: FilterItemTypes.multiselect,
          title: t("type"),
          boxTitle: t("type"),
          icon: gridIcon,
          itemsArray: types.map((el) => ({ label: t(el), value: el })),
          activeItems: filterByType,
          handleApply: handleSelectType,
        },
      ]}
    />
  );
};

export default NotificationsEmailFilter;

//   {
//     label: "Registration",
//     value: NotificationEmailTypes.registration,
//   },
//   {
//     label: "Reset Password",
//     value: NotificationEmailTypes.resetPassword,
//   },
//   {
//     label: "Verify Email",
//     value: NotificationEmailTypes.verifyEmail,
//   },
//   {
//     label: "All",
//     value: NotificationEmailTypes.all,
//   }

// ],
